import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { v4 as uuidv4 } from 'uuid';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';

import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import { useDropzone } from 'react-dropzone';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';
import Collapse from '@mui/material/Collapse';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import {alpha} from "@mui/material";

import { useDroppable, useDraggable } from '@dnd-kit/core';

import Bs4GenericField from './Bs4GenericField'
import Bs4MainDispatch from '../../Bs4MainDispatch';
import { SmallScreenContext } from '../../Bs4Theme/Bs4UxTemplates';
import Bs4Kartoteka from '../../Bs4Kartoteka';
import Bs4PopperMenu from '../../Bs4Components/Bs4PopperMenu';
import Bs4Popper from '../../Bs4Components/Bs4Popper';
import Bs4ViewFiles, {Bs4ViewFilesPreview} from '../../Bs4Components/Bs4ViewFiles';
import Bs4I18N from '../../Bs4I18N';
import { bs4RunSnackbar } from '../../Bs4Snackbar'
import { shallowEqual } from '../../Bs4Components/Bs4Utils';
import $script from 'scriptjs';

const CircularProgressWithLabel = (props) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', ...props.sx}}>
      <CircularProgress 
        variant="determinate" 
        value={props.value} 
        size={props.size} 
        //thickness={2}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          //color="text.secondary"
          sx={{fontSize: 10}}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
};

const ViewDropHereToUploadTheFile = (props) => {
  return (
    <Stack  
      direction="column"
      justifyContent='center' //'flex-start' //"space-around"
      alignItems='center'
      spacing={1}
      sx={{
        position:'absolute', 
        top:0, 
        right:0, 
        bottom: 0, 
        left: 0, 
        bgcolor: props.bgcolor, 
        borderRadius: '4px',
        // backdropFilter:'blur(2px)',
        border: 'solid',
      }}
      display={props.dragOver || props.isOverFile ? 'flex' : 'none'} 
    > 
      <SaveAltIcon sx={{flex: 2, width:'100%', maxWidth: 150, color: '#fff'}} />
      <Typography sx={{flex: 1, color: '#fff'}} variant='h6'>{props.text}</Typography>
    </Stack>
  )  
}

const UNDER_UPLOADING = 'Under uploading';

export default class Bs4File extends Bs4GenericField {

  initializeFormField() {
    super.initializeFormField();
    this.bs4ShowFiles(this.getValueBs4()); 
    //this.galleryMode = this.props.field.hidcolhead !== 1;
    this.galleryMode = this.props.field.pokpob === 1;        
  }
  
  text_Add_from_disk                = Bs4I18N.getTT("Add from disk", 'Dodaj z dysku', 'Bs4File');
  text_Update                       = Bs4I18N.getTT("Update", 'Aktualizuj', 'Bs4File');  
  text_Copy                         = Bs4I18N.getTT("Copy", 'Kopiuj', 'Bs4File');
  text_Cut                          = Bs4I18N.getTT("Cut", 'Wytnij', 'Bs4File');
  text_Paste                        = Bs4I18N.getTT("Paste", 'Wklej', 'Bs4File');
  text_Delete_selected              = Bs4I18N.getTT("Delete selected", 'Usuń zaznaczone', 'Bs4File');
  text_Download_marked_as_zip       = Bs4I18N.getTT("Download marked as zip", 'Pobierz zaznaczone jako zip', 'Bs4File');
  text_Download_as_zip              = Bs4I18N.getTT("Download as zip", 'Pobierz jako zip', 'Bs4File');
  text_Download                     = Bs4I18N.getTT("Download", 'Pobierz', 'Bs4File');
  text_Open_carde                   = Bs4I18N.getTT("Open file", 'Otwórz kartotekę', 'Bs4File');
  text_Send_message                 = Bs4I18N.getTT("Send with message", 'Wyślij komunikatem', 'Bs4File');
  text_Select_all                   = Bs4I18N.getTT("Select All", 'Zaznacz wszystkie', 'Bs4File');
  text_Unselect_all                 = Bs4I18N.getTT("Deselect all", 'Odznacz wszystkie', 'Bs4File');
  text_Drop_here_to_upload_the_file = Bs4I18N.getTT("Drop here to upload file", 'Upuść tutaj, aby wgrać plik', 'Bs4File');
  text_File_Control                 = Bs4I18N.getTT("File Control", 'Kontrolka Plikowa', 'Bs4File');
  text_Maximum_number_of_files      = Bs4I18N.getTT("The maximum number of files in the control is:", 'Maksymalna liczba plików w kontrolce to:', 'Bs4File');
  text_under_uploading              = Bs4I18N.getTT('Under uploading', 'Under uploading', 'Bs4File');
  text_Network_error                = Bs4I18N.getTT('Network error, possibly too large file: "?"', 'Error', 'Bs4File');
  text_Uploading_file_aborted       = Bs4I18N.getTT('Uploading file "?" aborted', 'Uploading file "?" aborted', 'Bs4File');
  text_Drag_and_drop_file           = Bs4I18N.getTT('Drag and drop a file here or select from disk.', 'Przeciągnij i upuść plik tutaj lub wybierz z dysku.', 'Bs4File');

  fileLimit = 0;
  listMode = false;  
  updateFile = false;

  setValueBs4 (value) {    
    if (!Array.isArray(value) && value) value = [value];
    this.setValue((value || []).map(id => ({id: id, key: uuidv4()})));
  }

  getValueBs4() {
    return (this.getValue() || []).map(item => item.id);
  }

  isDifferentValues (oldValue, newVaue) {        
    if (Array.isArray(oldValue) && Array.isArray(newVaue)) {
      if (oldValue.length !== newVaue.length) return true;     
      const oldDict = {};
      oldValue.forEach(file => oldDict[file.id] = file)
      for (const newFile of newVaue) {
        if (!oldDict[newFile.id]) return true
      }
    } else return true;
    return false;      
  }

  elementSetStore = (store) => {
    //console.log('... File ... ELEMENT_SET_STORE ... store', store);
    if (Array.isArray(store)) {
      this.updateFiles(store)
    } else {
      console.log('===Error=== ELEMENT_SET_STORE, store:', store);
    }
  }

  updateFiles = (files) => {
    if (files.length === 1 && this.fileLimit === 1) {
      this.setValue([]);
    }

    if (files.length === 1 && this.updateFile) {
      // Usuwanie zaznaczonych 'files' zostaną wstawione nowe.
      this.setValue(this.getValue().filter(file => !file.selected))
    }

    //Zachowanie ciągłości 'key';
    files.forEach(file => {
      const oldFile = this.getValue().find(oldFile => oldFile.id === file.id); 
      file.key = oldFile?.key || uuidv4();
    })

    //console.log('... File updateFile ...', files, this.getValue())

    const newIds = files.map(file => file.id);
    const oldFiles = this.getValue().filter(item => !newIds.includes(item.id));
    const newFiles = [...oldFiles, ...files];        

    if (this.galleryMode && newFiles.length > 0) {
      newFiles[0].filePreview = true;
    }

    this.setValueTrigger(newFiles)        
  }

  bs4ShowFiles = (fileIds) => {
    if (!fileIds.length) return;
    const formData = new FormData();
    const allparams = Bs4MainDispatch.getParserParams({'idiki': fileIds, currFormId: this.props.field.formId}, this.bs4KartotekaId)
    const com = 'Bs4ShowFiles';
    Bs4MainDispatch.commandConsole(com, allparams)
    formData.append('allparams', JSON.stringify(allparams));      
    fetch(Bs4MainDispatch.getUrlPath('web.php?com='+com), {method: 'POST', body: formData})
    .then(response => {return response.text();})
    .then(returnedText => {      
      try {
        const returnedJson = JSON.parse(returnedText);      
        this.updateFilesJson(returnedJson);
        // 2024-12-03 60604 – Przeciąganie plików między kontrolkami [Core]
        // this.resetOriginalValue();
      } catch (e) {
        console.log(e);
        console.log(returnedText);
      }      
    })
    .catch((error) => console.log(error));
  }

  setValueTrigger (newFiles) {
    this.trigger(Bs4GenericField.FOCUS_ENTER, this);
    this.setValue(newFiles);
    this.trigger(Bs4GenericField.FOCUS_LEAVE, this);
  }

  updateFilesJson = (returnedJson) => {
    // console.log('... File updateFilesJson ...', returnedJson)
    let items = [];

    if (Array.isArray(returnedJson.messgs)) {                
      items = returnedJson.messgs;
    } else if (returnedJson.messgs) {
      items = [returnedJson.messgs];
    }

    items.forEach(item => {
      if (item.data) {        
        this.updateFiles(item.data)
      } else if ('_Typ' in item) {        
        Bs4MainDispatch.parsingBs4ResponseMessagges(item, this.props.bs4KartotekaId)
      } else {
        console.log('===Error=== updateFiles item:', item)
      }
    })              
  }

  updateElementSetStore = (returnedJson, newFile) => {
    if (!newFile) return false;
    let items = [];
    if (Array.isArray(returnedJson.messgs)) {                
      items = returnedJson.messgs;
    } else {
      items = [returnedJson.messgs];
    }

    let update = 0;
    returnedJson.messgs = items.filter(item => {
      // console.log('...updateElementSetStore...', item)
      // if ('_Typ' in item && item._Typ === 'REFRESH_CARD_DATA') return false;      
      if ('_Typ' in item && item._Typ === 'ELEMENT_SET_STORE') {
        const files = item._Komunikat.value;
        for (const file of files) {
          if (file.oryg_name === newFile.flink) {
            for (const [key, value] of Object.entries(file)) newFile[key] = value;
            delete newFile.abort;
            if (newFile.setProgress) newFile.setProgress(111);
            update++;
            item._Komunikat.value = item._Komunikat.value.filter(file0 => file0 !== file);
            // console.log('...updateElementSetStore.OK..', newFile)
          } else {
            console.log('... File updateElementSetStore error ...', returnedJson, file, newFile);
          }
        }
        return false;
      } 
        
      return true;
    })

    if (!update) this.removeFile(newFile);
  }

  gatherFormValues() {
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    const bs4Option = bs4Kartoteka.getBs4Option(this.optionId);
    return bs4Option.bs4Form.gatherFormValues();
  }

  filePickerData = (message) => {
    // console.log('...Files.pickerData...', message);    
    this.handleOpenPicker(message);
  }

  uploadNewFilesOld = (files) => {
    if (!Array.isArray(files)) return;
    if (!files.length) return;
    const formData = new FormData();
    const selectedFiles = this.getValue().filter(file => file.selected)
    if (this.updateFile && selectedFiles.length === 1 && files.length === 1) {
        formData.append('aktualizacja', selectedFiles[0].id);
    } 
    files.forEach((file, index) => {
      formData.append(this.props.field.formId + '_file_' + file.name, file);
    });

    const fields = this.gatherFormValues();
    const details = { 
      currFormId: this.props.field.formId,
      formData: fields.fieldsDict,
      currCardViewId: this.bs4KartotekaId, 	
      currOptionId: this.optionId,
    };

    //console.log('... File upload .1.', details)    
    formData.append('allparams', JSON.stringify(Bs4MainDispatch.getParserParams(details, this.bs4KartotekaId)));

    fetch(Bs4MainDispatch.getUrlPath('web.php?com=Bs4UploadFile'), {method: 'POST', body: formData})
    .then(response => response.text())
    .then(returnedText => {
      try {
        const returnedJson = JSON.parse(returnedText);        
        this.updateFilesJson(returnedJson);
        this.updateFile = false;
      } catch (e) {
        console.log(e);
        console.log(returnedText);
      }
    })
    .catch((error) => {
      console.log(error);
      this.updateFile = false;
    })
  }

  uploadNewFilesGoogleDrivePicker = (account, docs, googleTemplate = false) => {
    // console.log('... uploadNewFilesGoogleDrivePicker ...', docs)
    if (!Array.isArray(docs)) return;
    if (docs.length < 1) return;
    
    const fields = this.gatherFormValues();
    const details = { 
      currFormId: this.props.field.formId,
      formData: fields.fieldsDict,
      currCardViewId: this.bs4KartotekaId, 	
      currOptionId: this.optionId,
      files: docs,
      account: account,
      googleTemplate: googleTemplate
    };

    Bs4MainDispatch.commandParser('Bs4PartnerFile', details, this.bs4KartotekaId);      
  }

  uploadNewFiles = (files) => {
    // console.log('... uploadNewFiles ...', files)
    if (!Array.isArray(files)) return;
    if (files.length < 1) return;
    const selectedFiles = this.getValue().filter(file => file.selected)

    const promises = [];
    if (this.updateFile && selectedFiles.length === 1 && files.length === 1) {
      promises.push(this.uploadNewFile(files[0], selectedFiles[0]));
    } else {
      files.forEach(file => {
        promises.push(this.uploadNewFile(file));
      });
    }
    
    Promise.all(promises).then((values) => {
      // console.log('...promises.all.completed...', values);
      const fields = this.gatherFormValues();
      const details = { 
        currFormId: this.props.field.formId,
        formData: fields.fieldsDict,
        currCardViewId: this.bs4KartotekaId, 	
        currOptionId: this.optionId,
        uploadCompleted: 1,
      };

      Bs4MainDispatch.commandParser('Bs4UploadFile', details, this.bs4KartotekaId);      
    });
  }

  uploadNewFile = (file, selectedFile) => {
    return new Promise((resolve, reject) => {      
      const formData = new FormData();    
      if (selectedFile) {
          formData.append('aktualizacja', selectedFile.id);
      } 
      
      //2024-02-22 Serwer dokonuje wszystkich konwersji nazw.
      //.replaceAll('—', '_').replaceAll('%', '_').replaceAll(';', '_').replaceAll('[', '_').replaceAll(']', '_');
      // console.log('...ffffffff....' ,file)

      // formData.append(this.props.field.formId + '_file_' + file.name, file);
      formData.append(this.props.field.formId + '_file_uploadedFiles', file);

      const key = uuidv4();
      const newFile = {
        id: key,
        flink: file.name,
        fsize_hum: file.size,
        tooltip: this.text_under_uploading,
        preview: UNDER_UPLOADING,
        remote: 0,
        icon: '',
        iconcolor: '',
        info: '',
        key: key,
      }

      // console.log('... uploadNewFile ...', file, selectedFile, newFile)      

      this.updateFiles([newFile]);

      const fields = this.gatherFormValues();
      const details = { 
        currFormId: this.props.field.formId,
        formData: fields.fieldsDict,
        currCardViewId: this.bs4KartotekaId, 	
        currOptionId: this.optionId,
      };

      formData.append('allparams', JSON.stringify( details ));

      // for (const [key, value] of formData.entries()) {
      //   console.log('... uploadNewFile .fd.', key, value);
      // }
      
      let xhr = new XMLHttpRequest();
      
      newFile.abort = () => {
        const msg = this.text_Uploading_file_aborted.replace('?', newFile.flink);
        newFile.aborted = true;
        xhr.abort();
        this.removeFile(newFile);
        bs4RunSnackbar(msg, 2);
      }

      xhr.open('POST', Bs4MainDispatch.getUrlPath('web.php?com=Bs4UploadFile')); 

      // upload progress event
      xhr.upload.addEventListener('progress', (e) => {
        if (newFile.setProgress) newFile.setProgress((e.loaded / e.total)*100);
      });

      // request finished event
      xhr.addEventListener('load', (e) => {
        // console.log('...>>> LOAD', xhr.readyState, xhr.status, xhr.statusText);
        resolve('LOAD '+file.name);
      });

      xhr.addEventListener("error", (e, a, ) => {
        console.log('...>>> ERROR', xhr.readyState, xhr.status, xhr.statusText);
        console.log('...>>> ERROR e a:', e, a);
        reject('ERROR '+file.name);
      });

      xhr.onreadystatechange = () => {
        // Call a function when the state changes.      
        // console.log('...>>> ONREADYSTATECHANGE', xhr.readyState, xhr.status, xhr.statusText);
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            try {
              const returnedJson = JSON.parse(xhr.response);        
              this.updateElementSetStore(returnedJson, newFile);
              this.updateFilesJson(returnedJson);
              this.updateFile = false;
            } catch (e) {
              console.log(e);
              console.log('===Error=== File uploadNewFile response :', xhr.response)  
              console.log('===Error=== File uploadNewFile newFile:', newFile)  
              this.removeFile(newFile);
            }
          } else {          
            if (newFile.aborted) return;
            console.log('===Error=== File uploadNewFile request :', xhr)  
            console.log('===Error=== File uploadNewFile newFile:', newFile)  
            this.removeFile(newFile);
            const msg = this.text_Network_error.replace('?', newFile.flink);
            bs4RunSnackbar(msg, 3);
          }
        }        
      };

      // send POST request to server

      xhr.send(formData);
    })    
  }

  fileCopy = () => {
    const selectedIds = this.getValue().filter(file => file.selected).map(file => file.id);
		window.localStorage.bs4fileCopyPaste = JSON.stringify(selectedIds);
		const item = {
			_Typ: 0,
			_Komunikat: "Zapamiętano wybrane pliki ("+selectedIds.length+")", 
		}
		Bs4MainDispatch.parsingBs4ResponseMessagges(item, this.bs4KartotekaId);		
	}

  fileCut = () => {
    const newFiles = this.getValue().filter(file => !file.selected)
    const selectedIds = this.getValue().filter(file => file.selected).map(file => file.id);
		window.localStorage.bs4fileCopyPaste = JSON.stringify(selectedIds);    
    this.setValueTrigger(newFiles)
		const item = {
			_Typ: 0,
			_Komunikat: "Usunięto i zapamiętano wybrane pliki ("+selectedIds.length+")", 
		}
		Bs4MainDispatch.parsingBs4ResponseMessagges(item, this.bs4KartotekaId);		
	}

  fileDragCut = (fileToCut) => {
    const newFiles = this.getValue().filter(file => file.id !== fileToCut.id)		
    // console.log('...fileDragCut...', fileToCut, newFiles, this.getValue());
    this.setValueTrigger(newFiles)
		// const item = {
		// 	_Typ: 0,
		// 	_Komunikat: "Usunięto i zapamiętano wybrane pliki ("+selectedIds.length+")", 
		// }
		// Bs4MainDispatch.parsingBs4ResponseMessagges(item, this.bs4KartotekaId);		
	}
	
  getFileCopyPaste = () => {
		try {
			const fileCopyPaste = JSON.parse(window.localStorage.bs4fileCopyPaste);
			if (Array.isArray(fileCopyPaste)) return fileCopyPaste;			
		} catch(error) {}
		return [];
	}

	filePaste = () => {
		// if (this.checkIfAdd(this.getFileCopyPaste().length)) {
		// 	this.getFiles(this.getFileCopyPaste());
		// }
    this.bs4ShowFiles(this.getFileCopyPaste()); 
	}

  fileDragPaste = (file) => {
		// if (this.checkIfAdd(this.getFileCopyPaste().length)) {
		// 	this.getFiles(this.getFileCopyPaste());
		// }
    this.bs4ShowFiles([file.id]); 
	}

  stripHtml(html) {
    //Usuwa html <...>, zostawia tylko text.
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }
  
  setMaximized = (item) => {
    this.trigger(Bs4GenericField.CHANGE_FILE_MAXIMIZED, item)
  }

  addFileMenu = () => {    
    //console.log('...addFileMenu..', this.props);
    return Object.entries(this.props.field.addFileMenu || {}).map(([key, name]) => {
      return {
        itemId: 'addFileMenu'+key,
        iconCls: 'fa-regular fa-sensor-cloud', 
        add: true,
        text: name, 
        enable: !this.readOnly,
        handler: () => {
          const fields = this.gatherFormValues();
          Bs4MainDispatch.commandParser('Bs4LinkFile', {selectedAddFile: key, currFormId: this.props.field.formId, formData: fields.fieldsDict}, this.bs4KartotekaId);          
        }
      }
    })
  }

  removeFile = (file) => {
    this.setValueTrigger(this.getValue().filter(item => item !== file));
  }

  dropzoneFilesAlternative = null;

  useDropzoneFiles = (props) => {
    const [dragOver, setDragOver] = React.useState(false);    
  
    const onDrop = React.useCallback((files) => {
      // console.log('=== onDrop ===', this.getLabelPlane(), files);      
      setDragOver(false);
    }, [setDragOver]);
  
    const onDropAccepted = React.useCallback((files) => {
      // console.log('=== onDropAccepted ===', this.getLabelPlane(), files);
      this.uploadNewFiles(files);
      setDragOver(false);
    }, [setDragOver]);
    
    const onDropRejected = React.useCallback((files) => {
      // console.log('=== onDropRejected ===', this.getLabelPlane(), files);
      // props.setUpdateFile(false);
      this.updateFile = false;
      props.setOpenDialogFileLimit(true);
    }, [props.setOpenDialogFileLimit]);
  
    const onError = React.useCallback((error) => {
      // console.log('=== onError ===', this.getLabelPlane(), error);
      // props.setUpdateFile(false);
      this.updateFile = false;
      setDragOver(false);
    }, [setDragOver]);
    
    const onDragEnter = React.useCallback((event) => {      
      // console.log('=== onDragEnter ===', this.getLabelPlane());
      setDragOver(true);
    }, [setDragOver]);
  
    const onDragLeave = React.useCallback((event) => {
      // console.log('=== onDragLeave ===', this.getLabelPlane());
      setDragOver(false);
    }, [setDragOver]);
  
    const onFileDialogOpen = React.useCallback((event) => {
      //console.log('=== onFileDialogOpen ===', this.getLabelPlane(), event, this.updateFile);
    }, []);
  
    const onFileDialogCancel = React.useCallback((event) => {
      // console.log('=== onFileDialogCancel ===', this.getLabelPlane(), event);
      // props.setUpdateFile(false);
      this.updateFile = false;
      setDragOver(false);
    }, [setDragOver]);
  
    const dropzone = useDropzone({
      disabled: props.disabled,
      noClick: true,
      noKeyboard: true,    
      onDrop: onDrop,
      onDropAccepted: onDropAccepted,
      onDropRejected: onDropRejected,
      onError: onError,
      onDragEnter: onDragEnter,
      onDragLeave: onDragLeave,
      onFileDialogOpen: onFileDialogOpen,
      onFileDialogCancel: onFileDialogCancel,
      multiple: this.fileLimit !== 1,
      //maxFiles: formField.fileLimit,
    });
  
    const dropzoneSingle = useDropzone({
      disabled: props.disabled,
      noClick: true,
      noKeyboard: true,    
      onDrop: onDrop,
      onDropAccepted: onDropAccepted,
      onDropRejected: onDropRejected,
      onError: onError,
      onDragEnter: onDragEnter,
      onDragLeave: onDragLeave,
      onFileDialogOpen: onFileDialogOpen,
      onFileDialogCancel: onFileDialogCancel,
      multiple: false,
    });
  
    return {
      dragOver,
      setDragOver,
      dropzone,
      dropzoneSingle,
    }
  }

  mainSize = 32;

  ViewFileArray = (props) => {
    const formField = this;    
    const boxProps = formField.listMode ? {display: 'flex', flexDirection: 'row', flexWrap: 'wrap'} : {}
    const mainSize = this.mainSize;
    const theme = useTheme();
    const [file, setFile] = React.useState(null);    

    return (
      <Box {...boxProps} maxHeight={props.modal ? 500 : null} 
        // 2024-08-21 overflow={'auto'} powoduje problem z AutoScroll w '@dnd-kit/core'
        // Prawdopodobnie nie jest konieczny.
        // 2024-12-03 A jednak jest konieczne !!!
        overflow={'auto'}
      > 
        {/* {formField.listMode ? null : <Divider/>} */}
        {formField.readOnly || (Array.isArray(props.files) && props.files.length > 0) ?
          <React.Fragment>
          {props.files.map(item => {   
            return (
              <React.Fragment key={item.key}>
                <formField.ViewFileItem
                  item={item}
                  selectClick={props.selectClick}
                  maximized={props.maximized === item}
                  setFile={setFile}
                  size={props.size}
                />
                {formField.listMode ? null : <Divider/>}
              </React.Fragment>
          )})}
          </React.Fragment>
        : 
          <Box 
            display='flex' 
            justifyContent='center' 
            alignItems='center' 
            width={!this.listMode ? '100%' : 'auto'}
            minHeight={mainSize}
            padding={0.2}
            sx={{
              borderStyle: 'dashed',
              borderColor: '#00000022', //theme.palette.text.disabled,
              borderRadius: (theme.shape.borderRadius * 2)+'px',
              borderWidth: '2px',
            }}
          >
            <Typography sx={{color: theme.palette.text.disabled}}>{formField.text_Drag_and_drop_file}</Typography>
          </Box>
        }
        <Bs4ViewFiles files={props.files} file={file} setFile={setFile} currFormId={formField.props.field.formId} bs4KartotekaId={formField.bs4KartotekaId} 
          // size={props.size}
        />
      </Box>
    )
  }

  ViewFileItem = (props) => {
    const formField = this;
    const theme = useTheme();
    const smallScreen = React.useContext(SmallScreenContext);
    const [mouseOver, setMouseOver] = React.useState(false)
    const boxRef = React.useRef();
    
    const preview = props.maximized;
    const colorI = props.item.iconcolor || "#999999";    
    const colorB = alpha(colorI, 0.2);
    const [progress, setProgress] = React.useState(0)
    props.item.setProgress = setProgress;
    const mainSize = this.mainSize;

    const {listeners, setNodeRef, setActivatorNodeRef, node} = useDraggable({
      id: formField.getElementId('Draggable_File_'+props.item.id),
      data: {
        formElement: this,
        type: 'file',
        props: props,
      },
    });

    const handleClickFlink = (e) => {
      if (parseInt(props.item.remote) === 1) {
        Bs4MainDispatch.commandParser('bs4FileClick', {targetObject: props.item.id, currFormId: this.props.field.formId}, this.bs4KartotekaId);
        return;
      }

      if (props.setFile) props.setFile(props.item);
    }

    // if (props.over)       
    // console.log('...ViewFileItem', this.getLabelPlane(), props.size, props)
    
    return (
      <Box
        ref={setNodeRef}
        selected={Boolean(props.item.selected)} 
        sx={{
          padding: 0, 
          width: preview || !this.listMode ? '100%' : 'auto', 
          // touchAction: 'none',
        }}
        onMouseEnter={(e) => setMouseOver(true)}
        onMouseLeave={(e) => setMouseOver(false)}
      >
        <Paper sx={{width: '100%', my: 0.2, p:0, bgcolor: preview ? '' : 'transparent'}} elevation={0}>
          <Box 
            width='100%' 
            display='flex' 
            flexDirection='row' 
            justifyContent={preview || !this.listMode ? 'space-between' : 'flex-start'}
            alignItems='center' 
            flexWrap='wrap'
          > 
            <Stack direction='row' alignItems='center'>
            {(props.item.preview === UNDER_UPLOADING) ?
              <Checkbox
                icon={<i className="fa-solid fa-xmark"/>}
                checkedIcon={<i className="fa-solid fa-xmark"/>}
                onChange={(e) => {if (props.item.abort) props.item.abort()}}
                size='small'
                sx={{width: mainSize, height: mainSize}}
                checked={true}
            />
              :
              <Checkbox
                onChange={(e) => props.selectClick(props.item)} 
                size='small'
                sx={{width: mainSize, height: mainSize}}
                checked={Boolean(props.item.selected)} 
              />
              }
              {this.listMode ? 
                null 
                :
                <React.Fragment>
                {(props.item.preview === UNDER_UPLOADING) ?
                  <CircularProgressWithLabel value={progress} size={mainSize} sx={{mr: 1}}/>                  
                 : 
                  <Avatar 
                    ref={setActivatorNodeRef} 
                    {...listeners}
                    sx={{bgcolor: colorB, width: mainSize, height: mainSize, mr: 1, touchAction: 'none'}}
                  >
                    <i className={props.item.icon} style={{color: colorI, fontSize: 18}}/>
                  </Avatar>                 
                }
                </React.Fragment> 
              }
              <Link href='#' onClick={handleClickFlink}>{props.item.flink}</Link>
            </Stack>
            {preview ? 
              <VisibilityOffIcon 
                onClick={(e) => {
                  formField.setMaximized(null); 
                  setMouseOver(false);
                }} 
                fontSize='small' 
                htmlColor='#00000055'
              />
              :
              <VisibilityIcon 
                onClick={(e) => {
                  formField.setMaximized(props.item)
                }} 
                fontSize='small' 
                htmlColor='#00000022' 
                sx={{visibility: mouseOver || smallScreen ? 'visible' : 'hidden'}}
              />
            }
          </Box>
          <Collapse in={preview} timeout="auto">
            <Box ref={boxRef} p={1}>
              {/* <formField.ViewPreviewFile {...props}/> */}
              <Bs4ViewFilesPreview {...props} file={props.item} open={Boolean(preview)} formVariant size={props.size}/>
              <Typography>{props.item.tooltip}</Typography>
              <Typography>{props.item.info}</Typography>
              <Typography>{props.item.fsize_hum}</Typography>
            </Box>
          </Collapse>          
        </Paper>
      </Box>
    )
  }

  ViewPreviewFile = (props) => {
    const handleClick = (event) => {
      // console.log('...???...file pre click', props)
      props.setFile(props.item);
      
      // Bs4MainDispatch.commandParser('bs4FileClick', {targetObject: props.item.id, inline: 1, currFormId: this.props.field.formId}, this.bs4KartotekaId);
    }

    //const link = Bs4MainDispatch.getUrlPath('showp.php?action=plik_pobierz&id='+props.item.id+'&disposition=inline'+'&showpreview=1');
    const link = Bs4MainDispatch.getUrlPath('showp.php?mid='+props.item.id);
    if ('pr1' === props.item.preview) return <img src={link} style={{maxWidth:'100%', loading: 'lazy', objectFit: 'scale-down'}} onClick={handleClick}/>
    if ('pr2' === props.item.preview) return <iframe src={link+'#view=fitH'} style={{border: 'none', frameBorder:0, width:'100%', aspectRatio: 1}}/>    
    if ('pr3' === props.item.preview) return <iframe src={link} style={{border: 'none', frameBorder:0, width:'100%', aspectRatio: 1}} sandbox="allow-same-origin allow-scripts allow-popups allow-forms"/>
    return null;
  }  

  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(this.getValue());
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    const [openDialogFileLimit, setOpenDialogFileLimit] = React.useState(false);
    const [maximized, setMaximized] = React.useState(null);  
    const [disabledDrop, setDisabledDrop] = React.useState(false);
    const theme = useTheme();   
    this.refFocus = React.useRef();
    const {activeCurrent} = React.useContext(this.bs4Form.activeCurrentContext);    

    const dropzoneFiles = this.useDropzoneFiles({setOpenDialogFileLimit, disabled: disabledDrop});
            
    const {isOver, setNodeRef} = useDroppable({
      //disabled: disabledDrop,
      id: formField.getElementId('DroppableFile'),
      data: {
        formElement: this,
        type: 'file',
      }
    });
    
    const isOverFile = isOver && activeCurrent.type === 'file';

    React.useEffect(() => {
      const runPicker = (message) => {
        let picker = null;
        if(message.selectGoogleTemplate){
            // Picker szablonu Google
            const docsView = new window.google.picker.DocsView()
            .setMimeTypes('application/vnd.google-apps.document')
            .setMode(window.google.picker.DocsViewMode.LIST)
            ;

            picker = new window.google.picker.PickerBuilder()
            .setDeveloperKey(message.apiKey)
            .setAppId(message.appID)
            .setOAuthToken(message.accessToken)
            .enableFeature(window.google.picker.Feature.NAV_HIDDEN)
            .setMaxItems(1)
            .addView(docsView)
            .setCallback((data) => {
                if (data.action === 'cancel') {
                console.log('User clicked cancel/close button')
                return;
                }
        
                formField.uploadNewFilesGoogleDrivePicker(message.account, data.docs, true);
            })
            .build();
        }
        else{
            // Zwykły Picker
            const docsView = new window.google.picker.DocsView()
            .setIncludeFolders(true)
            .setSelectFolderEnabled(true)
            .setMode(window.google.picker.DocsViewMode.LIST)
            ;

            picker = new window.google.picker.PickerBuilder()
            .setDeveloperKey(message.apiKey)
            .setAppId(message.appID)
            .setOAuthToken(message.accessToken)
            .enableFeature(window.google.picker.Feature.NAV_HIDDEN)
            .enableFeature(formField.fileLimit !== 1 ? window.google.picker.Feature.MULTISELECT_ENABLED : null)
            .addView(docsView)
            .setCallback((data) => {
                if (data.action === 'cancel') {
                console.log('User clicked cancel/close button')
                return;
                }
        
                formField.uploadNewFilesGoogleDrivePicker(message.account, data.docs);
            })
            .build();
        }
        picker.setVisible(true);
        const elements = document.getElementsByClassName('picker-dialog');
        for(let i = 0; i < elements.length; i++) {
        elements[i].style.zIndex = "2000";
        elements[i].style.borderRadius = theme.shape.borderRadius+'px';
        }
      }

      this.handleOpenPicker = (message) => {        
        // console.log('...handleOpenPicker...', message)
        try {
          // Zadziała jeżeli serwisy google były wcześniej załadowane.
          runPicker(message);
        } catch (error) {
          // Jeżeli serwisy google nie były wcześniej załadowane, zostaną załadowane teraz.
          // Następnym razem uruchomienie picker'a może być szybsze.
          $script('https://apis.google.com/js/api.js', () => {
            window.gapi.load('client:picker', async function () {
              await window.gapi.client.load('https://www.googleapis.com/discovery/v1/apis/drive/v3/rest');
              runPicker(message);            
            });
          });        
        }        
      }
    }, []);

    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        const newFiles = this.getValue();        
        setValue(newFiles);
        if (this.galleryMode && newFiles.length > 0) newValue.forEach(item => {
            if (item.filePreview) setMaximized(item);
            delete item.filePreview;
        })
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      });      

      this.on(Bs4GenericField.CHANGE_FILE_MAXIMIZED, (item) => {
        setMaximized(item);
      })        
    }, [error]);
    
    const onClickDialogFileLimit = (event) => {
      setOpenDialogFileLimit(false);
      dropzoneFiles.setDragOver(false);
    }

    const getAllIds = () => {
      return value.map(file => file.id);
    }

    const getSelectedIds = () => {
      return value.filter(file => file.selected).map(file => file.id);
    }

    const isItemUpdatable = () => {
      const selected = value.filter(file => file.selected);
      return !this.readOnly && selected.length === 1 && parseInt(selected[0].remote) !== 1;
    }

    const allFilesLenght = getAllIds().length;
    const selectedFilesLenght = getSelectedIds().length;
    const fileCount = value.length;
    
    const getMenu = () => {
      return [{
        itemId: 'itemOpen', 
        iconCls: 'fas fa-folder-open',
        add: true,
        text: this.text_Add_from_disk, //'Dodaj z dysku',
        enable: !this.readOnly,
        handler: () => {
          this.updateFile = false;
          try {
            dropzoneFiles.dropzone.open();
          } catch(error) { 
            this.dropzoneFilesAlternative.dropzone.open();            
          }
        }
      }, {
        itemId: 'itemDownload', 
        iconCls: 'fa-solid fa-arrow-down-to-bracket',
        add: true,
        text: this.text_Download+` (${selectedFilesLenght || allFilesLenght})`, //'Pobierz',
        enable: allFilesLenght > 0,
        handler: () => {
          const allIds = getAllIds();          
          const selectedIds = getSelectedIds();          
          const fileIds = selectedIds.length > 0 ? selectedIds : allIds;
          for (const fileId of fileIds) {
            Bs4MainDispatch.commandParser('bs4FileClick', {targetObject: fileId, currFormId: this.props.field.formId}, this.bs4KartotekaId);
          }
        }
      }, ...formField.addFileMenu(), {
        itemId: 'itemUpdate', 
        iconCls: 'fas fa-file-import',        
        text: this.text_Update, //'Aktualizuj',
        enable: isItemUpdatable(),
        handler: () => {
          this.updateFile = true;          
          try {
            dropzoneFiles.dropzoneSingle.open();
          } catch(error) {
            this.dropzoneFilesAlternative.dropzone.open();
          }
        }
      }, {
        itemId: 'itemPaste',
        iconCls: 'fas fa-paste',  					
        text: this.text_Paste,
        enable: !this.readOnly && formField.getFileCopyPaste().length > 0,
        handler: () => {
          formField.filePaste();
        }
      }, {
        itemId: 'itemDivider',
        enable: true,
      }, {
        itemId: 'itemCopy',
        iconCls: 'fas fa-copy',
        text: this.text_Copy,
        enable: selectedFilesLenght > 0,
        handler: () => {
          formField.fileCopy();
        }
      }, {
        itemId: 'itemCut',
        iconCls: 'fas fa-cut',
        text: this.text_Cut,        
        enable: !this.readOnly && selectedFilesLenght > 0,
        handler: () => {
          formField.fileCut();
        }
      }, {
        itemId: 'itemDel',
        iconCls: 'fas fa-minus-circle redIcon',  
        text: this.text_Delete_selected, //'Usuń zaznaczone',
        enable: ! this.readOnly && selectedFilesLenght > 0,
        handler: () => {
          const newFiles = value.filter(item => !item.selected)
          formField.setValueTrigger(newFiles)
        }
      }, {
        itemId: 'itemToZip',
        iconCls: 'fas fa-file-archive',
        text: this.text_Download_as_zip+` (${selectedFilesLenght || allFilesLenght})`, //'Pobierz jako zip', 
        enable: allFilesLenght > 0,
        handler: () => {
          const allIds = getAllIds();          
          const selectedIds = getSelectedIds();          
          const fileIds = selectedIds.length > 0 ? selectedIds : allIds;   
          Bs4MainDispatch.commandParser('Bs4FilesAsZip', {currFormId: this.props.field.formId, js_files: fileIds.toString()}, this.bs4KartotekaId);                      
        }
      }, {
        itemId: 'itemOpenCard',
        iconCls: 'fas fa-external-link-alt',
        text: this.text_Open_carde, //'Otwórz kartotekę', 
        enable: selectedFilesLenght === 1,
        handler: () => {
          const selectedIds = getSelectedIds();
          // console.log('... Otwórz kartotekę ...', selectedIds)
          if (selectedIds.length === 1) {
            Bs4MainDispatch.commandParser('Bs4FileCard', {js_files: selectedIds.toString()}, this.props.bs4KartotekaId);            
          }
        }					
      }, {
        itemId: 'itemSendMessage',
        iconCls: 'fas fa-share',
        text: this.text_Send_message, //'Wyślij komunikatem', 
        enable: selectedFilesLenght > 0,
        handler: () => {
          const selectedIds = getSelectedIds()
          if (selectedIds.length > 0) {
            Bs4MainDispatch.commandParser('Bs4SendIMToFile', {currFormId: this.props.field.formId, js_files: selectedIds.toString()}, this.props.bs4KartotekaId);            
          }
        }					
      }, {
        itemId: 'itemSelectAll', 
        iconCls: 'fas fa-check-double',
        text: this.text_Select_all, //'Zaznacz wszystkie',
        enable: fileCount > 0,
        handler: () => {
          value.forEach(item => {item.selected = true;});
          formField.setValue([...value])        
        }
      }, {
        itemId: 'itemDeselectAll', 
        iconCls: 'fas fa-eraser',
        text: this.text_Unselect_all, //'Odznacz wszystkie',
        enable: selectedFilesLenght > 0,
        handler: () => {							
          value.forEach(item => {item.selected = false});
          formField.setValue([...value])
        }
      }]	 
    };

    const [anchorEl, setMenuAnchorEl] = React.useState(null);
    const [menuItemSelected, setMenuItemSelected] = React.useState(null);

    const handleMenuClick = React.useCallback((event) => {
      setMenuAnchorEl(event.currentTarget);
    }, [setMenuAnchorEl]);

    const handleMenuAddClick = React.useCallback((event) => {      
      const menuitems = getMenu().filter(menu => menu.enable && (menu.itemId === 'itemOpen' || menu.itemId === 'itemUpdate'));
      if (menuitems.length > 0) menuitems[0].handler();
    }, [getMenu]);

    const handleMenuClose = React.useCallback((event) => {
      setMenuAnchorEl(null);
    }, [setMenuAnchorEl]);

    const handleMenuSelect = React.useCallback((menu) => {
      setMenuItemSelected(menu);
    }, [setMenuItemSelected]);

    React.useEffect(() => {
      if (menuItemSelected) {
        menuItemSelected.handler();
        setMenuItemSelected(null);
      }
    }, [menuItemSelected]);

    const selectClick = React.useCallback((item) => {
      if (!item) return
      item.selected = !item.selected
      formField.setValue([...value])
    }, [value]);

    //transparent
    const colorA = alpha(theme.palette.primary.main, 0.1);
    const colorB = alpha(theme.palette.info.main, 0.5);    

    // console.log('...ViewFile.....', dragOver || isOverFile, formField.text_Maximum_number_of_files + ' ' + formField.fileLimit.toString());
    // const paperclip = this.isParamSelected('ATRYB_MINIMIZE') || parseInt(this.props.field.hidcolhead) === 1;
    
    return (
      <Paper         
        {...(formField.readOnly ? {} : dropzoneFiles.dropzone.getRootProps({ className: "dropzone" }))} 
        sx={{
          position: 'relative', 
          bgcolor: Boolean(maximized) ? colorA : 'transparent', 
          // border: 'solid #0000ff'
        }}
        //variant='outlined'
        elevation={0}
      >        
        <input {...dropzoneFiles.dropzone.getInputProps()}/>
        <input {...dropzoneFiles.dropzoneSingle.getInputProps()}/>
        <FormControl 
          ref={(node) => {
            this.refFocus.current = node;
            setNodeRef(node)
          }} 
          fullWidth 
          error={error.error}
          // sx={{border: 'solid #ff0000'}}
        >
          {!this.isParamSelected('ATRYB_MINIMIZE') ?
          <formField.ViewComponentMinimize 
            value={value}
            maximized={maximized}
            handleMenuAddClick={handleMenuAddClick}
            handleMenuClick={handleMenuClick}
            anchorEl={anchorEl}
            onMenuClose={handleMenuClose}
            onMenuSelect={handleMenuSelect}
            getMenu={getMenu}
            selectClick={selectClick}
            dragOver={dropzoneFiles.dragOver}
            isOverFile={isOverFile}
            bgcolor={colorB}
            setDisabledDrop={setDisabledDrop}
            setOpenDialogFileLimit={setOpenDialogFileLimit}
          />
          :
          <formField.ViewComponentContent 
            value={value}
            maximized={maximized}
            handleMenuAddClick={handleMenuAddClick}
            handleMenuClick={handleMenuClick}
            anchorEl={anchorEl}
            onMenuClose={handleMenuClose}
            onMenuSelect={handleMenuSelect}            
            getMenu={getMenu}
            selectClick={selectClick}
          />
          }
          <FormHelperText>{error.helperText}</FormHelperText>
        </FormControl>
        <ViewDropHereToUploadTheFile dragOver={dropzoneFiles.dragOver} isOverFile={isOverFile} bgcolor={colorB} text={formField.text_Drop_here_to_upload_the_file}/>
        <Dialog open={openDialogFileLimit}>
          <DialogTitle>{formField.text_File_Control}</DialogTitle>
          <DialogContent>          
            <DialogContentText>{formField.text_Maximum_number_of_files + ' ' + formField.fileLimit.toString()}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClickDialogFileLimit} autoFocus>Ok</Button>
          </DialogActions>
        </Dialog>
      </Paper>
    )
  }

  //<i class="fa-solid fa-paperclip"></i>
  // ATRYB_MINIMIZE
  ViewComponentMinimize = (props) => {
    const formField = this;
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const numberOfFiles = props.value.length;
    
    const [size, setSize] = React.useState(null);
    const ref = React.useRef(null);

    React.useEffect(() => {
      const resizeObserver = new ResizeObserver((e) => {
        if (ref.current) {
          const rect = ref.current.getBoundingClientRect();
          setSize({width: rect.width, height: rect.height});
        }
      });
      if (ref.current) resizeObserver.observe(ref.current);
      
      return () => { 
        resizeObserver.disconnect();
      }

    }, [ref.current, setSize]);

    const handleClick = (event) => {
      event?.stopPropagation();
      setAnchorEl(anchorEl ? null : event.currentTarget); 
    }

    const handleClose = (event) => {
      event?.stopPropagation();
      setAnchorEl(null)
    }

    React.useEffect(() => {
      this.closeBs4Popper = () => {
        setAnchorEl(null);
      }
    })

    return (
      <FormControl fullWidth>
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Box>
          <IconButton onClick={handleClick}>
            <i className="fa-solid fa-paperclip"/>
          </IconButton>
          {numberOfFiles > 0 ? 
            <Typography component='span' sx={{color: theme.palette.text.secondary}}>&nbsp;:&nbsp;{numberOfFiles}</Typography> 
          : null}
        </Box>
        <Bs4Popper anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} bs4kartotekaid={formField.bs4KartotekaId}>
          <Box ref={ref} padding={1}>
            <formField.ViewComponentContent {...props} modal size={size}/>
          </Box>
        </Bs4Popper>        
      </FormControl>
    )    
  }

  ViewComponentContent = (props) => {
    const formField = this;
    //transparent
    const [disabledDrop, setDisabledDrop] = React.useState(false);

    const dropzoneFiles = this.useDropzoneFiles({setOpenDialogFileLimit: props.setOpenDialogFileLimit, disabled: disabledDrop});
    this.dropzoneFilesAlternative = dropzoneFiles

    React.useEffect(() => {
      if (props.setDisabledDrop) {
        props.setDisabledDrop(true);
      } else {
        setDisabledDrop(true);
      }

      return () => {
        if (props.setDisabledDrop) {
          props.setDisabledDrop(false);
        }         
      }
    }, [setDisabledDrop, props.setDisabledDrop])

    return (
      <Box 
        {...(formField.readOnly ? {} : dropzoneFiles.dropzone.getRootProps({ className: "dropzone" }))}
        // sx={{border: 'solid #00ff00'}}
      >
        <input {...dropzoneFiles.dropzone.getInputProps()}/>
        <input {...dropzoneFiles.dropzoneSingle.getInputProps()}/>
        <FormLabel component='div'>
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
            <formField.Bs4Label/>
            <span></span>             
            <div>
              {!this.readOnly ?
              <IconButton onClick={props.handleMenuAddClick}>
                <AddIcon/>
              </IconButton>
              : null }
              <IconButton onClick={props.handleMenuClick}>
                <MoreVertIcon />
              </IconButton>
              <Bs4PopperMenu 
                id="long-menu" 
                anchorEl={props.anchorEl} 
                open={Boolean(props.anchorEl)} 
                onClose={props.onMenuClose} 
              >
                {props.getMenu().filter(menu => menu.enable).map((menu) => (
                  menu.itemId === 'itemDivider'
                  ?
                  <Divider key={menu.itemId}/>
                  :
                  <MenuItem 
                    key={menu.itemId} 
                    id={menu.itemId} 
                    onClick={() => {
                      props.onMenuClose();
                      props.onMenuSelect(menu);
                      // menu.handler()
                    }}
                    sx={{
                      maxWidth: '89vw',
                      //overflow: 'hidden',
                      whiteSpace: 'pre-line', 
                      wordWrap: 'break-word', 
                      overflowWrap: 'anywhere',
                    }}
                  >
                    <ListItemIcon><div className={menu.iconCls}/></ListItemIcon>
                    <Typography variant="inherit">{menu.text}</Typography>                                
                  </MenuItem>
                ))}
              </Bs4PopperMenu>
            </div>
          </Stack>
        </FormLabel>          
        <formField.ViewFileArray files={props.value} selectClick={props.selectClick} maximized={props.maximized} modal={props.modal} size={props.size}/>    
        <ViewDropHereToUploadTheFile dragOver={dropzoneFiles.dragOver} isOverFile={false} bgcolor={props.bgcolor} text={formField.text_Drop_here_to_upload_the_file}/>              
      </Box>
    )
  }
}